import { connect } from 'react-redux';

import MBZeroSportTiles from '../../../components/navigation/MobileNavigation/MBZeroSportTiles';

function mapStateToProps(state) {
  return {
    tags: state.getIn(['navigation', 'tags']),
    product: state.getIn(['application', 'product']),
  };
}

export default connect(mapStateToProps, null)(MBZeroSportTiles);
